import React from 'react';
import styled, {
  keyframes,
} from 'styled-components';
import { primaryColor1 } from '../Utils';

const animation = keyframes`
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.8;
  }

  100% {
    opacity: 0;
  }
`;

interface DotProps {
  size: number;
  animationDelay: number;
}
const Dot = styled.div<DotProps>`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  background-color: ${primaryColor1};
  border-radius: 50%;
  box-shadow: 0 0 2px black;
  animation: ${animation} 1.5s infinite;
  animation-delay: ${props => props.animationDelay}s;
`;
const Root = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

interface Props {
  width: number;
  height: number;
  dotSize: number;
  extraStyles?: React.CSSProperties;
}
export default (props: Props) => {
  const {
    width, height, dotSize,
    extraStyles = {},
  } = props;
  const style: React.CSSProperties = {
    ...extraStyles,
    width: `${width}px`,
    height: `${height}px`,
  };
  return (
    <Root style={style}>
      <Dot size={dotSize} animationDelay={0}/>
      <Dot size={dotSize} animationDelay={0.3}/>
      <Dot size={dotSize} animationDelay={0.6}/>
    </Root>
  );
};
